import PasswordModify from './Index.vue'

PasswordModify.install = function(Vue) {
  Vue.component(PasswordModify.name, PasswordModify)
}

export default PasswordModify
